import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, Link} from "@material-ui/core"
import React from "react"
import {injectIntl} from "react-intl"
import XsButton from "../../global/ui/xsButton/xsButton"
import {observer} from "mobx-react"
import ConsentDialogStore from "./ConsentDialogStore"
import XsCheckbox from "../../global/ui/xsCheckbox/xsCheckbox"

function ConsentDialog(props) {
	return (
		<Dialog
			id="createUniversalTemplate"
			open={ConsentDialogStore.isOpen}
			onClose={() => ConsentDialogStore.close(props.requestForm)}
			className="xs-base-dialog"
			classes={{
				paper: "xs-paper-dialog xs-width-paper-900 fullWidth"
			}}
			disableBackdropClick={true}
			maxWidth="md"
		>
			<DialogTitle className="xs-info">
				<div className="xs-header">
					<div
						style={{position: "absolute", right: 24, top: 16, cursor: "pointer"}}
						onClick={() => {
							ConsentDialogStore.close(props.requestForm)
						}}
					>
						<i className="fal fa-times fa-lg" />
					</div>
					<div className="xs-header-title">Spracúvanie osobných údajov</div>
				</div>
			</DialogTitle>
			<DialogContent>
				<Grid container className="pl-2 pt-4">
					<Grid item xs={12}>
						Spracúvanie osobných údajov:{" "}
						<Link
							className="pointer underline"
							onClick={() => window.open("https://www.siea.sk/o-siea/ochrana-osobnych-udajov/")}
						>
							https://www.siea.sk/o-siea/ochrana-osobnych-udajov/
						</Link>
					</Grid>
					<Grid item xs={12} className="pl-8 pt-4">
						<XsCheckbox field={props.requestForm.$("consent")} labelVariant="button" />
					</Grid>
					<Grid item xs={12} className="pt-4 redDanger">
						Bez udelenia súhlasu so spracúvaním poskytnutých osobných údajov nie je možné žiadosť uložiť alebo odoslať.
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Grid item container justify="space-between" className="ma-4">
					<Grid item>
						<XsButton
							className="xs-primary"
							icon={<i className="fal fa-times " />}
							text="Zrušiť"
							onClick={() => ConsentDialogStore.close(props.requestForm)}
						/>
					</Grid>
					<Grid item>
						<XsButton
							className="xs-primary"
							icon={<i className="fal fa-arrow-right" />}
							disabled={!props.requestForm.$("consent").value}
							text="Pokračovať"
							onClick={(e) => props.requestForm.onSubmit(e)}
						/>
					</Grid>
				</Grid>
			</DialogActions>
		</Dialog>
	)
}

export default injectIntl(observer(ConsentDialog))

